/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Flow_TitleInputs */

const en_mk_tb_flow_title = /** @type {(inputs: Mk_Tb_Flow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the next step clear for everyone`)
};

const id_mk_tb_flow_title = /** @type {(inputs: Mk_Tb_Flow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah berikutnya jelas untuk semua orang`)
};

/**
* | output |
* | --- |
* | "Make the next step clear for everyone" |
*
* @param {Mk_Tb_Flow_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_flow_title = /** @type {((inputs?: Mk_Tb_Flow_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Flow_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_flow_title(inputs)
	return en_mk_tb_flow_title(inputs)
});